<template>
    <div>
        <div class="logo_div">
            <div class="logo_title">万品京选</div>
        </div>
        <div style="padding: 5%">
            <!--        <h1 style="text-align: center;margin-top: 50px">-->
            <!--            <wp_img src="images/icon_3.png" type="app" size="70px"> </wp_img>-->
            <!--            <div>万品精选</div>-->
            <!--        </h1>-->

            <divider>超级会员登录</divider>
            <van-cell-group style="margin-top: 5%">
                <div class="login_input_div">
                    <van-field
                            class="login_input"
                            label-width="70px"
                            v-model="username"
                            label="用户名"
                            placeholder="请输入用户名"
                            required
                            clearable
                            right-icon="manager"
                    ></van-field>
                </div>

                <div class="login_input_div">
                    <van-field
                            class="login_input"
                            label-width="70px"
                            v-model="password"
                            type="password"
                            label="密码"
                            placeholder="请输入登录密码"
                            required
                            clearable
                            right-icon="lock"
                    ></van-field>
                </div>
            </van-cell-group>
            <div style="text-align: right; margin-top: 10px; margin-right: 5px; font-size: 15px; color: #999999" @click="forgetPassword">
                忘记密码
            </div>

            <van-button style="margin-top: 9%; border-radius:4px" @click="login(null)" type="danger" size="large">登录
            </van-button>
        </div>
    </div>
</template>

<script>
    import {Dialog} from 'vant';

    export default {
        name: "Wp_login",

        inject:["wp_group_owner_app"],

        data() {
            return {
                username: '',
                password: '',
                msg: '',
            }
        },
        methods: {

            forgetPassword(){

                this.wp_group_owner_app.showLogin = false;
                this.$router.push("reset_password");

            },

            login(fn) {
                let _userData = {
                    uname: this.username,
                    upwd: this.password,
                };
                if (_userData.uname && _userData.upwd) {

                    this.$login(_userData, response=> {
                        this.$log(response);
                        let code = response.code;
                        if (code === 200) {
                            let loginInfo = response.data[0];
                            let user = {
                                username: loginInfo.u_name,
                                userId: loginInfo.id,
                                pid: loginInfo.u_pid,
                                alipay: loginInfo.u_alpay,//支付宝账号
                                bankName: loginInfo.u_bank,//开户行
                                cardNomber: loginInfo.u_card,//银行卡号
                                bank_account: loginInfo.u_bank_account,// 账号名称
                                openid: loginInfo.u_openid,//微信openid
                                truename: loginInfo.u_payname,// 真实姓名
                                userType: loginInfo.u_type,// 0群主1代理商
                                userPhone: loginInfo.u_phone,//手机号
                                taobao_pid: loginInfo.taobao_pid,//淘宝pid
                                wx_name: loginInfo.wx_name,//微信头像
                                wx_img: decodeURIComponent(loginInfo.wx_img),//微信昵称
                                pdd_pid: decodeURIComponent(loginInfo.pdd_pid),//拼多多pid
                                meituan_pid: loginInfo.meituan_pid,//美团pid
                            };
                            this.$store.commit('login', user);
                            if(fn){
                                fn("success");
                            }
                            //登录成功后，刷新页面
                            this.$emit('reload');

                            if(this.$route.query.url){
                                window.location.href = decodeURIComponent(this.$route.query.url);
                                // window.location.replace(decodeURIComponent(this.$route.query.url))
                            }
                        } else {
                            this.msg = response.msg;
                            Dialog({message: this.msg});
                        }
                    })
                } else {
                    Dialog({message: "用户名或密码不能为空"});
                    let test = this.$store.state.test;
                    if (test === '0987') {
                        let user = {
                            username: "v156",//jd53256
                            userId: "445",
                            pid: "1825325610",
                            alipay: "zfb_123456",//支付宝账号
                            bankName: "",//开户行
                            cardNomber: "",//银行卡号
                            bank_account: "",// 账号名称
                            openid: "",//微信openid
                            truename: "王小二",// 真实姓名
                            userType: 0,// 0群主1代理商
                            // username: "wwwtest",//771111
                            // userId: "1042",
                            // pid: "123456789",
                            // alipay: "ww",//支付宝账号
                            // bankName: "www",//开户行
                            // cardNomber: "5676878898",//银行卡号
                            // bank_account: "",// 账号名称
                            // openid: "o7r5oxB_fAT5uazLrlY_OiieZM0M",//微信openid
                            // truename: "郭军辉",// 真实姓名
                            // userType: 0,// 0群主1代理商
                        };
                        this.$store.commit('login', user);
                        //登录成功后，刷新页面
                        this.$emit('reload');
                    }
                }

            }
        }
    }
</script>

<style>
    .login_input_div {
        margin-top: 5%;
        padding: 2px;
        border-radius: 4px;
        border: 1px solid #E52212
    }

    .login_input {
        font-size: 17px
    }

    .logo_div {
        width: 100%;
        margin-top: -100px;
        height: 300px;
        background-color: #E52212;
        border-radius: 60px;

    }

    .logo_title{
        font-size: 40px;
        font-weight: bolder;
        color:white;
        position: absolute;
        width: 100%;
        text-align: center;
        margin-top: 170px;
    }
</style>
